<template>
  <div class="home">
    <page-title :title="title"></page-title>
    <p>This is the toplevel page of the jonnypickett site.</p>
    <p>I am a software engineer, a family man, a baseball fan, and an art appreciator.</p>
    <p></p>
    <p>Right now I'm really excited about serverless technologies. I've finally committed to understanding data modeling with NoSQL databases such as DynamoDB. Big ups to <a href="https://www.alexdebrie.com" target="_blank">Alex DeBrie</a> and his <a href="https://www.dynamodbbook.com" target="_blank">"The DynamoDB Book"</a>.<br> I get that engineering high off of working on decoupled, fault-tolerant systems. I'll probably try to convince you that we should use an event based microservice approach as a way to reduce points of failure.</p>
    <p></p>
    <p>I really love film. Take a look at the <router-link to="/last-ten-films">last ten films</router-link> I watched.</p>
    <p>My favorite baseball team is the <a href="https://cdn.kqed.org/wp-content/uploads/sites/10/2014/10/RS12812_458071300-scr.jpg" target="_blank">San Francisco Giants</a>, and yes, the National League is the best league.</p>
    <p>My favorite painting is <a href="https://collections.lacma.org/node/233733" target="_blank">Joan Mitchell's East Ninth Street</a> on display at LACMA.</p>
    <p></p>
    <p>The <router-link to="/about">about</router-link> page goes into more detail about who I am.<br> The <router-link to="/current">current projects</router-link> page details what I am currently working on,<br> and the <router-link to="/resume">resume</router-link> page has a link to my current resume to give a good overview of my experience.</p>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
export default {
  name: 'home',
  data () {
    return {
      title: 'Hi. I\'m Jonny.'
    }
  },
  components: {
    PageTitle
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// Home.vue?8ecf9b46